
import React from 'react';
import { useParams } from 'react-router-dom';
import { useInvitationValidation } from '@/hooks/useInvitationValidation';
import { useInvitationAcceptance } from '@/hooks/useInvitationAcceptance';
import { InviteLoadingScreen } from '@/components/invite/InviteLoadingScreen';
import { InviteErrorCard } from '@/components/invite/InviteErrorCard';
import { InviteRegistrationForm } from '@/components/invite/InviteRegistrationForm';

export const InviteAcceptance = () => {
  const { token } = useParams<{ token: string }>();
  const { invitation, loading, error } = useInvitationValidation(token);
  const {
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    isSubmitting,
    handleAcceptInvitation
  } = useInvitationAcceptance();

  if (loading) {
    return <InviteLoadingScreen />;
  }

  if (error || !invitation) {
    return <InviteErrorCard error={error || 'Unknown error'} token={token} />;
  }

  return (
    <InviteRegistrationForm
      invitation={invitation}
      password={password}
      setPassword={setPassword}
      confirmPassword={confirmPassword}
      setConfirmPassword={setConfirmPassword}
      isSubmitting={isSubmitting}
      onSubmit={handleAcceptInvitation}
    />
  );
};

export default InviteAcceptance;
